import type { LanguageFn } from "highlight.js";

export const CLI_TOOL_PATTERN = "npm|npx|pnpm|yarn|bun|node|nest|next|deno|git|docker|kubectl|prisma|turbo|vite|tsc|tsx|ts-node";
export const CLI_SUBCOMMAND_PATTERN = "install|uninstall|add|remove|init|create|new|run|build|start|dev|test|generate|deploy|push|pull|clone|commit|checkout|merge|status|diff|log|exec|apply|get|set|update|delete|describe|help|version|info";

export const cliGrammar: LanguageFn = () => ({
	name: "shell",
	aliases: ["bash", "sh", "zsh", "plaintext"],
	contains: [
		{ className: "comment", begin: /#/, end: /$/ },
		{
			className: "string",
			variants: [
				{ begin: /"/, end: /"/ },
				{ begin: /'/, end: /'/ },
			],
		},
		{ className: "built_in", begin: new RegExp(`\\b(${CLI_TOOL_PATTERN})\\b`) },
		{ className: "attr", begin: /\s(-{1,2}[\w-]+)/ },
		{ className: "keyword", begin: new RegExp(`\\b(${CLI_SUBCOMMAND_PATTERN})\\b`) },
	],
});

export const prismaGrammar: LanguageFn = () => ({
	name: "Prisma",
	aliases: ["schema.prisma"],
	keywords: {
		keyword: "model enum type datasource generator view relation",
		type: "String Boolean Int BigInt Float Decimal DateTime Json Bytes Unsupported",
		literal: "true false null",
	},
	contains: [
		{ className: "comment", begin: /\/\//, end: /$/ },
		{ className: "string", begin: /"/, end: /"/, contains: [{ begin: /\\./ }] },
		{ className: "meta", begin: /@@?[A-Za-z][\w.]*/ },
		{ className: "number", begin: /\b\d+(?:\.\d+)?\b/ },
	],
});

export function looksLikePrismaSchema(code: string): boolean {
	return /(^|\n)\s*(?:model|enum|datasource|generator|view|type)\s+[A-Za-z_]\w*\s*\{/m.test(code);
}
